import createIcon from '../../createIcon';

/**
 * @component @name Castle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgOVYxMUgxOVYzSDE3VjVIMTVWM0gxM1Y1SDExVjNIOVY1SDdWM0g1VjExSDNWOUgxVjIxSDEwVjE4QzEwIDE2LjkgMTAuOSAxNiAxMiAxNkMxMy4xIDE2IDE0IDE2LjkgMTQgMThWMjFIMjNWOUgyMVpNMTEgMTJIOVY5SDExVjEyWk0xNSAxMkgxM1Y5SDE1VjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Castle = createIcon('Castle', [
  [
    'path',
    {
      d: 'M21 9V11H19V3H17V5H15V3H13V5H11V3H9V5H7V3H5V11H3V9H1V21H10V18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18V21H23V9H21ZM11 12H9V9H11V12ZM15 12H13V9H15V12Z',
      key: '1o144q',
    },
  ],
]);

export default Castle;
